const namespace = window.VelotricBundle
if (!namespace?.["cards"]?.ready) { throw new Error("vl-bundle-cards.js must execute before vl-bundle-cart.js") }
const sharedApi = namespace["cards"].api
if (!sharedApi) { throw new Error("Missing cards named API contract") }
export const Card = sharedApi["Card"]